export default "__VITE_ASSET__EPJsmbnI__"